import React, { useRef, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ActivityIndicator } from 'react-native';
import { MaterialIcons, FontAwesome } from '@expo/vector-icons';
import { useDispatch } from 'react-redux';
import { tenantActions } from '../../../redux/tenant.actions';
import { showErrorToast } from '../../helpers';

const CertList = (props) => {
  const { certificate, certificatesItem, handleDelete, handleEdit, handleUpload, key } = props;
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);

  const onFileChange = (e) => {
    const files = e?.target?.files;
    if (files && files.length > 0) {
      const file = files[0];
      setIsUploading(true);
      dispatch(
        tenantActions.uploadFiles([file], 'certificate-doc', (uploadResponse) => {
          setIsUploading(false);
          if (uploadResponse && uploadResponse.data && uploadResponse.data.length > 0) {
            const rawUrl = uploadResponse.data[0];
            const finalUrl =
              typeof rawUrl === 'string'
                ? rawUrl
                : rawUrl?.openbrixName || rawUrl?.url || '';
            if (handleUpload) {
              handleUpload(finalUrl, certificatesItem);
            }
          } else {
            showErrorToast('Failed to upload file');
          }
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
        })
      );
    }
  };

  const onEditClick = () => {
    if (handleEdit) {
      handleEdit(certificatesItem);
    } else if (handleUpload && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <View key={key} style={styles.container}>
      {/* Hidden file input for direct file replacement */}
      {handleUpload && !handleEdit && (
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={onFileChange}
          accept="image/*,application/pdf,.doc,.docx"
        />
      )}

      <View style={styles.textContainer}>
        <Text style={styles.title}>{certificate.name}</Text>
        <View style={certificatesItem?.is_seen ? styles.badge : styles.badgeNotseen}>
          <Text style={[styles.badgeText, { color: certificatesItem?.is_seen ? 'green' : 'red' }]}>
            {certificatesItem?.is_seen ? 'Seen' : 'Not Seen'}
          </Text>
        </View>
      </View>

      <View style={styles.iconsContainer}>
        {(handleEdit || handleUpload) && (
          <TouchableOpacity
            onPress={onEditClick}
            disabled={isUploading}
            style={styles.iconBtn}
            title="Edit Certificate"
          >
            {isUploading ? (
              <ActivityIndicator size="small" color="#0288D1" />
            ) : (
              <FontAwesome name="pencil" size={20} color="#0288D1" />
            )}
          </TouchableOpacity>
        )}
        <TouchableOpacity
          onPress={() => {
            if (certificatesItem?.certificate_url) {
              window.open(certificatesItem.certificate_url, '_blank');
            }
          }}
          style={styles.iconBtn}
          title="View Certificate"
        >
          <FontAwesome name="eye" size={20} color="#0288D1" />
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => {
            if (handleDelete) {
              handleDelete(certificatesItem);
            }
          }}
          style={styles.iconBtn}
          title="Delete Certificate"
        >
          <MaterialIcons name="delete" size={22} color="#EF4444" />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: 16,
    marginBottom: 8,
    borderRadius: 8,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 4,
    elevation: 3,
  },
  textContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    marginRight: 12,
  },
  title: {
    fontSize: 16,
    fontWeight: '500',
    marginRight: 8,
    color: '#1E293B',
  },
  badge: {
    backgroundColor: '#d4f8d4',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 12,
  },
  badgeNotseen: {
    backgroundColor: 'rgba(255, 86, 72, 0.12)',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 12,
  },
  badgeText: {
    color: 'green',
    fontWeight: 'bold',
  },
  iconsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  iconBtn: {
    padding: 4,
    cursor: 'pointer',
  },
});

export default CertList;
